<div class="d-flex flex-column card goal-card"
     [ngClass]="{ 'mw-100': isReordering }">
    <div class="card-header d-flex align-items-center goal-header"
         role="button"
         (click)="toggleCollapseItem()"
         [ngClass]="{ 'goal-collapsed': !isExpanded }">
        <div class="d-flex align-items-center flex-fill gap-2"
             [ngClass]="{ 'me-2': !isEditing }">
            @if (isDraggable && isReordering) {
                <i class="fal fa-grip-dots-vertical pe-1 gripper"
                   id="goalGripper"></i>
            }
            <i [ngClass]="GoalIconClass"
               adaptTooltip="Goal"></i>
            <h4 class="my-0">
                <span [ngClass]="{ 'me-2': !!goal.description }">{{ goal.name }}</span>
                @if (goal.description) {
                    <adapt-display-goal-description [goal]="goal"></adapt-display-goal-description>
                }
            </h4>
            @if (!isEditing) {
                <adapt-goal-status [status]="goal.status"
                                   class="ms-auto"></adapt-goal-status>
            } @else {
                <adapt-select-goal-status [status]="goal.status"
                                          (statusChange)="saveGoalStatus($event)"
                                          class="ms-auto"
                                          data-tour="select-goal-status"></adapt-select-goal-status>
            }
        </div>
        <button class="ms-start btn btn-blank"
                [adaptButtonIcon]="expandButtonIcon"
                data-tour="expand-goal"></button>
    </div>

    <div [collapse]="!isExpanded"
         [isAnimated]="true"
         class="goal-card-collapse"
         [ngClass]="{ 'goal-editing': isEditing }">
        @if (isExpanded || graphRendered) {
            <div class="card-body d-flex flex-column">
                @if (statusText) {
                    <small class="ms-auto text-black">{{ statusText }}</small>
                }
                <adapt-goal-measurements-graph [goal]="goal"
                                               [isEditing]="isEditing"
                                               [width]="graphWidth"
                                               (contentReady)="graphRendered = $event"></adapt-goal-measurements-graph>
                @if (isEditing) {
                    <div class="d-flex mt-3"
                         data-tour="goal-bottom-buttons">
                        <button adaptButton="addBorderless"
                                [adaptBlockingClick]="recordNewMeasurement">Add measurement</button>
                        <button class="ms-auto"
                                adaptButton="editBorderless"
                                [adaptBlockingClick]="editGoal"
                                adaptTooltip="Edit this goal"></button>
                        <button adaptButton="deleteBorderless"
                                [adaptBlockingClick]="deleteGoal"
                                adaptTooltip="Delete this goal"></button>
                    </div>
                }
            </div>
        }
    </div>
</div>
